'use client';

import { useHasActiveZangiaPlus } from '@/features/jobs/hooks/useHasActiveZangiaPlus';
import BuyPlusButton from './BuyPlusButton';
import { plusCopy } from './plusCopy';
import { ZangiaPlusLockIcon } from './ZangiaPlusLockIcon';

export default function ZangiaPlusQuickComponent({
  isEnglish = false,
}: {
  isEnglish?: boolean;
}) {
  const { isAuthLoading, hasPlus, user } = useHasActiveZangiaPlus();
  const t = isEnglish ? plusCopy.en : plusCopy.mn;
  if (isAuthLoading || hasPlus) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-4 rounded-xl bg-primary-50 p-4 sm:flex-row sm:items-center">
      <ZangiaPlusLockIcon variant="plain" />
      <div className="min-w-0 flex-1">
        <h3 className="text-base font-medium text-primary-700">
          {t.quickTitle}
        </h3>
        <p className="mt-1 text-sm leading-5 text-gray-800">
          {t.quickSubtitleBefore}
          <span className="font-medium text-primary-700">
            {t.quickSubtitleBrand}
          </span>
          {t.quickSubtitleAfter}
        </p>
      </div>
      <BuyPlusButton isEnglish={isEnglish} className="mt-0 w-full sm:w-auto" />
    </div>
  );
}
